import { connect } from 'react-redux';
import { getIsMobile } from '../../src/publicSession/selectors';
import { hasFirstTimeFlag } from '../redux/firstTimeFlags/selectors';
import { FirstTimeFlag } from '../redux/firstTimeFlags/constants';
import { dropFirstTimeFlag } from '../redux/firstTimeFlags';
var mapStateToProps = function (state, ownProps) {
    var isMobile = getIsMobile(state);
    var showFTUE;
    if (isMobile) {
        showFTUE = false;
    }
    else if (typeof ownProps.showFTUE !== 'undefined') {
        showFTUE = ownProps.showFTUE;
    }
    else {
        showFTUE = !!hasFirstTimeFlag(state, FirstTimeFlag.IsDollarInputMessageNotShown);
    }
    return {
        showFTUE: showFTUE,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        dropFTUE: function () {
            return dispatch(dropFirstTimeFlag({
                flag: FirstTimeFlag.IsDollarInputMessageNotShown,
            }));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=DollarPriceInput.container.js.map